import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import "@/utils/axiosPlantInterceptor"; // Global plant_id interceptor
import { Toaster } from "sonner";
import PlannerDashboard from "@/components/PlannerDashboard";
import UnifiedLogin from "@/components/UnifiedLogin";
import useSessionValidation from "@/hooks/useSessionValidation";
import { isUserLoggedIn } from "@/utils/sessionManager";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Session Validator Component - validates session periodically
const SessionValidator = ({ children }) => {
  useSessionValidation();
  return children;
};

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  // Use sessionStorage-based check (clears on browser close)
  const loggedIn = isUserLoggedIn();
  
  if (!loggedIn) {
    return <Navigate to="/login" replace />;
  }
  
  return (
    <SessionValidator>
      {children}
    </SessionValidator>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Unified login for all users */}
          <Route path="/login" element={<UnifiedLogin />} />
          
          {/* Main dashboard - shows content based on user role */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <PlannerDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Redirect old routes to unified login */}
          <Route path="/vendor-login" element={<Navigate to="/login" replace />} />
          <Route path="/vendor-portal" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
